import tree from "../../../components/tree.vue"
import Sortable from 'sortablejs'
import QS from 'qs';

export default {
    name: "checkManagement",
    components: {
        tree,
    },
    data() {
        return {
            checked: false,
            dialogVisible: false,
            height: '550',
            list: [
            ], 
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                checkName: [
                    { required: true, message: this.$t('PlatformSettings.form.inputCheckName'), trigger: 'blur' },
                ],
            },
            form: {
                checkName: '',
                checkReference: ''
            },
            selected: [],
            companyId: '',
            SortDrag: []
        };
    },
    created() {

    },
    mounted() {
        this.sortable('t1', 'list')
        this.getCheckList()
    },
    methods: {
        sortable(className, targetName) {
            console.log(className, targetName)
            const table = document.querySelector('.' + className + ' .el-table__body-wrapper tbody')
            const that = this
            Sortable.create(table, {
                handle: '.handle',
                onEnd({ newIndex, oldIndex }) {
                    console.log(newIndex, oldIndex)
                    if (newIndex === oldIndex) return
                    that[targetName].splice(newIndex, 0, that[targetName].splice(oldIndex, 1)[0])
                    const newData = []
                    that.list.forEach((item, index) => {
                        newData[index] = {
                            id: item.id,
                            checkIndex: item.checkIndex,
                            checkName: item.checkName,
                            companyId: item.companyId,
                            createTime: item.createTime,
                            lastUser: item.lastUser,
                            updateTime: item.updateTime,
                            rank: index + 1
                        }

                    })
                    const param = {
                        sSpotCheckPoList: newData
                    }   
                    that.$store.dispatch('checkManagement/GET_MOVECARCHECK', param).then(res => {
                        if (res) {
                            console.log(res)
                            if (res.data.code == 200) {
                                that.getCheckList()
                                that.$message.success(this.$t('PlatformSettings.form.editSortSuccess'))
                            } else {
                                that.$message.error(this.$t('PlatformSettings.form.editSortFail'))
                            }
                        }
                    })
                }
            })
        },
        getCheckList() {
            let param = {
                companyId: sessionStorage.getItem('companyId'),
            }
            this.$store.dispatch('checkManagement/GET_SELECTCARCHECK', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data
                    }
                }
            })
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getCheckList();
        },
        addUser() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })

        },
        editUser() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.checkName = this.selected[0].checkName
                this.form.checkReference = this.selected[0].checkReference
            })


        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        companyId: sessionStorage.getItem('companyId'),
                        checkName: this.form.checkName,
                        checkReference: this.form.checkReference
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('checkManagement/GET_INSERTCARCHECK', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('PlatformSettings.form.addCheckSuccess'))
                                this.dialogFormVisible = false;
                                this.getCheckList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        param.id = this.selected[0].id
                        this.$store.dispatch('checkManagement/GET_UPDATECARCHECK', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('PlatformSettings.form.editCheckSuccess'))
                                this.dialogFormVisible = false;
                                this.getCheckList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }
                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                checkName: '',
                checkReference: ''
            }
        },
        closeDia() {
            this.form = {
                checkName: '',
                checkReference: ''
            }
            this.dialogFormVisible = false;
        },
        deleteUser() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { companyId: sessionStorage.getItem('companyId'),id: this.selected[0].id }
                    this.$store.dispatch('checkManagement/GET_DELELECARCHECK', param).then(response => {
                        if (response.data.code == 200) {
                            this.getCheckList();
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        
        changeSort(item) {
            this.columns = [];
            this.$nextTick(function () {
                this.columns = item;
            });
        },
        
        ListSetting() {
            this.$refs.listSet.dialogVisible = true;
        },
    },
};
